import script from "./Editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./Editor.vue?vue&type=script&setup=true&lang=ts"

import "./Editor.vue?vue&type=style&index=0&id=6ff8a3bc&scoped=true&lang=css"
import "./Editor.vue?vue&type=style&index=1&id=6ff8a3bc&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ff8a3bc"]])